import { Injectable, inject } from '@angular/core';
import { SwUpdate, VersionEvent } from '@angular/service-worker';
import { DiagnosticsService } from './diagnostics.service';

@Injectable({ providedIn: 'root' })
export class AppUpdateService {
  private readonly swUpdate = inject(SwUpdate);
  private readonly diagnostics = inject(DiagnosticsService);

  constructor() {
    if (!this.swUpdate.isEnabled) {
      this.diagnostics.addBreadcrumb('service-worker', 'disabled');
      return;
    }

    this.diagnostics.addBreadcrumb('service-worker', 'enabled', {
      controlled: Boolean(navigator.serviceWorker?.controller),
      controllerState: navigator.serviceWorker?.controller?.state,
    });
    this.swUpdate.versionUpdates.subscribe((event) => this.handleVersionEvent(event));
    this.swUpdate.unrecoverable.subscribe((event) => {
      this.diagnostics.captureAppMessage('Service worker unrecoverable state', {
        reason: event.reason,
      }, 'error');
      void this.diagnostics.flush().finally(() => window.location.reload());
    });

    void this.swUpdate.checkForUpdate();
  }

  private handleVersionEvent(event: VersionEvent): void {
    this.diagnostics.addBreadcrumb('service-worker', event.type, event as unknown as Record<string, unknown>);

    if (event.type !== 'VERSION_READY') {
      return;
    }

    void this.swUpdate.activateUpdate().then(() => {
      this.diagnostics.addBreadcrumb('service-worker', 'activated update; reloading');
      window.location.reload();
    });
  }
}
